module.exports = __webpack_public_path__ + "static/media/crossoff.3e9c0792.svg";